import { Translate } from '@galigeo-store/ui-lib';

export class TranslationUtils {
  static async loadTranslation(lang: string): Promise<void> {
    let translations;
    switch (lang) {
      case 'fr':
        translations = (await import(`../locales/fr.json`)).default;
        break;
      case 'en':
        translations = (await import(`../locales/en.json`)).default;
        break;
      case 'it':
        translations = (await import(`../locales/it.json`)).default;
        break;
      case 'es':
        translations = (await import(`../locales/es.json`)).default;
        break;
      case 'pt':
        translations = (await import(`../locales/pt.json`)).default;
        break;
      case 'de':
        translations = (await import(`../locales/de.json`)).default;
        break;
      case 'nl':
        translations = (await import(`../locales/nl.json`)).default;
        break;
      default:
        translations = (await import(`../locales/en.json`)).default;
        lang = 'en';
    }
    Translate.load(lang, translations);
  }
}
